/**
 * Colori del grafico del rendimento (F-182), fuori dal componente perché
 * servono anche alla legenda della pagina: i colori restano token (ADR-0005),
 * qui c'è solo quale token va a quale curva.
 */

import type { PerformanceMetric } from './performance-series';

/** `#rrggbb` → `rgba(…)`. Un token in altra forma passa com'è: meglio pieno che sbagliato. */
export function withAlpha(color: string, alpha: number): string {
  const match = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(color);
  if (!match) return color;
  const [r, g, b] = match.slice(1).map((part) => parseInt(part, 16));
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/** Le curve di confronto: mai verde o rosso, che qui significano guadagno e perdita. */
const OVERLAY_TOKENS: Record<PerformanceMetric, string> = {
  unrealized: '--color-text-muted',
  realized: '--color-cat-2',
  combined: '--color-cat-1',
};

export function overlayToken(metric: PerformanceMetric): string {
  return OVERLAY_TOKENS[metric];
}
